<template>
  <v-layout v-resize="onResize" column>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card elevation="2" class="mt-4 mb-4 ml-4 mr-4">
        <h2 class="text-right mt-4 mb-4 ml-4 mr-4" :class="`${bgColor}--text`">
          Folios Disponibles: {{ folios_disponibles }} /
          Extendidos : {{ folios_disponibles_ruta_extendida }}
        </h2>
        <v-card-text>
          <v-card-title>Datos de Paquete</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" lg="3" md="3">
                <v-combobox v-model="informacion.contenido" label="Contenido de Paquete" :rules="requird"
                  :items="contenidos_empaque" prepend-icon=" mdi-cube-outline" item-text="contenido"></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="3">
                <v-combobox v-model="informacion.tipo_paquete" label="Tipo Paquete" :rules="requird"
                  :items="tipos_paquete" item-text="contenido" :append-outer-icon="'mdi-help'"
                  @click:append-outer="dialog_tipo_paquete = true"></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="3">
                <v-text-field v-model="informacion.peso_paquete" suffix="Kgs" label="Peso" counter="20"
                  hint="Peso del paquete 0.1 - 70.99" :rules="requird_cantidad" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="3">
                <v-text-field v-model="informacion.valor_estimado" prefix="$" label="Valor Estimado" counter="20"
                  :rules="requird" type="number"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-title>Remitente</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" lg="12" md="12">
                <v-combobox v-model="remitente_selecionado" label="Nombre" counter="50" :items="remitentes"
                  :rules="requird" :search-input.sync="search" item-text="nombre" return-object
                  @change="buscarDestinatarios()">
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="12">
                <v-text-field v-model="remitente.calle" ref="txtCalleRemiente" label="Callle" counter="30"
                  :rules="rules_50"></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" lg="3" md="4">
                <v-text-field v-model="remitente.numero_exterior" label="No." counter="20" :rules="rules_20">
                </v-text-field>
              </v-col>
              <v-col cols="6" sm="6" lg="3" md="4">
                <v-text-field v-model="remitente.numero_interior" label="No.int" counter="20"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="4">
                <v-text-field v-model="remitente.codigo_postal" label="CP." @keyup.enter.native="buscarCodigo(1)"
                  counter="20" :append-outer-icon="'mdi-book-search'" @click:append-outer="buscarCodigo(1)"
                  :loading="loading_codigo_postal" :rules="rules_5_requerid" type="number"
                  hint="Ingrese el codigo postal" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="4" md="4">
                <v-combobox ref="cmbRemitente" v-model="remitente.colonia" label="Colonia" :items="colonia_remitente"
                  :rules="requird"></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" lg="4" md="4">
                <v-text-field v-model="remitente.ciudad" label="Ciudad" counter="100" :rules="rules_100" readonly>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="4" md="4">
                <v-text-field v-model="remitente.telefono" label="Telefono" counter="25" :rules="rules_25">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-title>Destinatario</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" lg="12" md="12">
                <v-combobox v-model="destintario_seleccionado" label="Nombre" counter="50" :items="destintarios"
                  item-text="nombre" :rules="requird" return-object @change="rellenarDestinatario()"></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="12">
                <v-text-field v-model="destintario.calle" label="Calle" ref="txtCalleDestintario" counter="30"
                  :rules="rules_50"></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" lg="3" md="6">
                <v-text-field v-model="destintario.numero_exterior" label="No." counter="20" :rules="rules_20">
                </v-text-field>
              </v-col>
              <v-col cols="6" sm="6" lg="3" md="6">
                <v-text-field v-model="destintario.numero_interior" label="No.int" counter="20"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="6">
                <v-text-field v-model="destintario.codigo_postal" label="CP." @keyup.enter.native="buscarCodigo(2)"
                  counter="5" ype="number" :rules="rules_5_requerid" hint="Ingrese el codigo postal"
                  :append-outer-icon="'mdi-book-search'" @click:append-outer="buscarCodigo(2)"
                  :loading="loading_codigo_postal"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="6">
                <v-combobox v-model="destintario.colonia" label="Colonia" :items="colonia_destintario"
                  ref="cmbDestintario" :rules="requird"></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="6">
                <v-text-field v-model="destintario.ciudad" label="Ciudad" counter="100" :rules="rules_100" readonly>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="6">
                <v-text-field v-model="destintario.telefono" label="Telefono" counter="25" :rules="rules_25">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="3" md="12">
                <v-text-field v-model="destintario.entre_calles" label="Referencia" counter="25"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="mostrarConfirmacion()">Generar Guia</v-btn>
        </v-card-actions>
      </v-card>

      <!-- SECCION DE VALIDACIÓN DE FOLIOS -->

      <v-dialog v-model="dialog_question" max-width="400">
        <v-card>
          <v-card-title class="text-h5 text-center">
            Verifica tu información
          </v-card-title>

          <v-card-text>
            Favor de revisar la información registrada en el formmulario, como
            lo son:
            <br />
            <br />
            <ul>
              <li>Cantidad de Folios</li>
              <li>Codigo Postal y Ciudad de Destintario</li>
              <li>Codigo Postal y Ciudad de Remitente</li>
            </ul>
            <br />
            <br />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="generarFolioEnvio()">
              Confirmar
            </v-btn>

            <v-btn color="green darken-1" text @click="dialog_question = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOGO DE TIPO DE PAQUETE -->
      <v-dialog v-model="dialog_tipo_paquete" max-width="600">
        <v-card>
          <v-img contain :src="require('@/assets/medida.jpeg')"></v-img>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog_tipo_paquete = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOGO DE ERROR EN SISTEMA -->

      <v-dialog v-model="dialog_error" max-width="400">
        <v-card>
          <v-card-title class="text-h7 text-justify">
            Hubo un problema en la generación
          </v-card-title>
          <v-card-text>
            {{ error_encabezado }}
            <br />
            <br />
            <b>Detalle del error</b>
            <br />
            {{ error_detalle }}
            <br />
            <br />
            <center>
              Telefono/whatsapp Soporte:
              <br />
              <b>
                <a href="https://wa.me/524773576653" target="_blank">
                  +52477-357-66-53
                </a>
              </b>
              <br />
              Horario de Atención:
              <br />
              <b> 9:00 AM - 7:00 PM</b>
            </center>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog_error = false">
              De Acuerdo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- COMPONENTE PARA LA CARGA DE INFORMACIÓN -->
      <v-overlay :value="loading">
        <v-progress-circular indeterminate color="primary" :width="10" size="80"></v-progress-circular>
      </v-overlay>

      <!-- DIALOG DE MENSAJE DEL SERVIDOR -->
      <v-dialog v-model="dialog_mensaje" max-width="500">
        <v-card>
          <v-card-title class="text-h5 text-center">
            {{ titulo }}
          </v-card-title>
          <v-card-text>
            {{ mensaje }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="dialog_mensaje = false">
              Entendido
            </v-btn>

            <v-btn color="green darken-1" text @click="dialog_mensaje = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- DIALOG DE MENSAJE CORRECTO -->
      <v-dialog persistent v-model="dialog_mensaje_correcto" max-width="350">
        <v-card>
          <v-card-title class="text-h5 text-center">
            {{ titulo }}
          </v-card-title>
          <v-card-text color="red darken-1">
            <pdf :src="url" ref="pdf"></pdf>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text @click="imprimirGuiaDigital">
              Imprimir Guias
            </v-btn>

            <v-btn color="red darken-1" text @click="dialog_mensaje_correcto = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-layout>
</template>

<script>
import pdf from "vue-pdf";
import service from "@/core/Servicio.js";
export default {
  components: {
    pdf,
  },
  data: () => ({
    guia_extendida: false,
    remitente_selecionado: {
      nombre: "",
      calle: "",
      numero_exterior: "",
      numero_interior: "",
      codigo_postal: "",
      colonia: "",
      ciudad: "",
      telefono: "",
    },
    destintario_seleccionado: {
      nombre: "",
      calle: "",
      numero_exterior: "",
      numero_interior: "",
      codigo_postal: "",
      colonia: "",
      ciudad: "",
      telefono: "",
      entre_calles: "",
      ruta_extendida: false
    },
    contenido_selecionado: null,
    tipo_paquete_seleccionado: null,
    folios_disponibles: 0,
    folios_disponibles_ruta_extendida: 0,
    valid: true,
    bgColor: "primary",
    dialog_mensaje_correcto: false,
    dialog: false,
    search: "",
    url: "",
    titulo: "",
    isMobile: false,
    mensaje: "",
    dialog_mensaje: false,
    dialog_error: false,
    error_encabezado: "",
    bandera_funcion: false,
    error_detalle: "",
    loading: false,
    loading_codigo_postal: false,
    dialog_question: false,
    dialog_tipo_paquete: false,
    informacion: {
      contenido: "",
      tipo_paquete: "",
      valor_estimado: 0,
      peso_paquete: 1,
      alto: 0,
      ancho: 0,
      largo: 0,
      cantidad: 1,
      cliente_id: localStorage.getItem("id"),
    },
    remitente: {
      nombre: "",
      calle: "",
      numero_exterior: "",
      numero_interior: "",
      codigo_postal: "",
      colonia: "",
      ciudad: "",
      telefono: "",
    },
    destintario: {
      nombre: "",
      calle: "",
      numero_exterior: "",
      numero_interior: "",
      codigo_postal: "",
      colonia: "",
      ciudad: "",
      telefono: "",
      entre_calles: "",
    },
    rules_50: [
      (v) => v.length <= 50 || "Maximo 50 caracteres",
      (v) => !!v || "Campo Requerido",
    ],
    rules_100: [
      (v) => !!v || "Campo Requerido",
      (v) => v.length <= 100 || "Maximo 100 caracteres",
    ],
    rules_25: [
      (v) => v.length <= 25 || "Maximo 25 caracteres",
      (v) => !!v || "Campo Requerido",
    ],
    rules_20_requerid: [(v) => v.length <= 20 || "Maximo 20 caracteres"],
    rules_5_requerid: [(v) => v.length <= 5 || "Maximo 5 caracteres"],
    rules_20: [
      (v) => v.length <= 20 || "Maximo 20 caracteres",
      (v) => !!v || "Campo Requerido",
    ],
    rules_30: [
      (v) => v.length <= 30 || "Maximo 30 caracteres",
      (v) => !!v || "Campo Requerido",
    ],
    requird_cantidad: [
      (v) => v > 0.1 || "Limte permitido 0.1  - 70.99",
      (v) => v < 70.99 || "Limte permitido 0.1  - 70.99",
      (v) => !!v || "Campo Requerido",
    ],
    requird: [(v) => !!v || "Campo Requerido"],
    colonia_remitente: [],
    colonia_destintario: [],
    contenidos_empaque: [],
    tipos_paquete: [],
    tipos_paquete_objecto: [],
    destintarios: [],
    remitentes: [],
  }),
  created() {
    service
      .buscarRemitentes(localStorage.getItem("id"))
      .then((response) => {
        if (response.data.response_flag == 1) {
          response.data.response.forEach((remitente, count) => {
            remitente.nombre = (count + 1) + ". " + remitente.nombre
          });
          this.remitentes = response.data.response;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    service
      .consultarContenidos(null)
      .then((response) => {
        if (response.data.response_flag == 1) {
          //Convertimos el arreglo en un arreglo de strings
          let contenidos = response.data.response;
          contenidos.forEach((element) => {
            this.contenidos_empaque.push(element.contenido);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });

    service
      .consultarPaquetes(null)
      .then((response) => {
        if (response.data.response_flag == 1) {
          this.tipos_paquete_objecto = response.data.response;
          this.tipos_paquete_objecto.forEach((element) => {
            this.tipos_paquete.push(element.contenido);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.consultarFoliosDisponibles();
  },
  methods: {
    limpiarRotulador() {
      this.$refs.form.reset();
    },
    onResize() {
      if (window.innerWidth < 500) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    imprimirGuiaDigital() {
      window.open(this.url, "Download");
    },
    buscarCodigo(tipo) {
      let codigo = null;
      if (tipo == 1) {
        this.colonia_remitente = [];
        codigo = this.remitente.codigo_postal;
      } else {
        this.colonia_destintario = [];
        codigo = this.destintario.codigo_postal;
      }
      this.loading_codigo_postal = true;
      service
        .buscarCodigoPostal(codigo)
        .then((response) => {
          if (response.data.response_flag == 1) {
            if (response.data.response.length > 0) {
              this.loading_codigo_postal = false;
              //Tomamos un elemento del arreglo
              let elemento_seleccionado = response.data.response[0];

              if (elemento_seleccionado.ruta_extendida === 1) {
                if (tipo != 1) {
                  this.titulo = "Ruta Extendida";
                  this.mensaje =
                    "El codigo postal ingresado pertenece a una ruta extendida.";
                  this.dialog_mensaje = true;
                }
                this.guia_extendida = true;
                if (this.destintario_seleccionado.ruta_extendida != undefined) {
                  this.destintario_seleccionado.ruta_extendida = true;
                }
              } else {
                this.guia_extendida = false;
                if (this.destintario_seleccionado.ruta_extendida != undefined) {
                  this.destintario_seleccionado.ruta_extendida = false;
                }
              }
              response.data.response.forEach((element, index) => {
                //Revisamos si el codigo postal no es ruta extendida
                if (index == 0) {
                  if (tipo == 1) {
                    this.remitente.ciudad = element.ciudad;
                  } else {
                    this.destintario.ciudad = element.ciudad;
                  }
                }
                if (tipo == 1) {
                  this.colonia_remitente.push(element.colonia);
                  this.$refs.cmbRemitente.focus();
                  this.remitente.colonia = "";
                } else {
                  this.colonia_destintario.push(element.colonia);
                  this.$refs.cmbDestintario.focus();
                  this.destintario.colonia = "";
                }
                index++;
              });
            } else {
              this.titulo = "Codigo Postal Incorrecto";
              this.mensaje =
                "El codigo postal ingresado no se encuentra en el sistema, verifica información";
              this.dialog_mensaje = true;
              this.loading_codigo_postal = false;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generarNuevoRemitente() {
      console.log(this.remitente_selecionado);
    },
    buscarDestinatarios() {
      this.$refs.txtCalleRemiente.focus();
      this.remitente.id = this.remitente_selecionado.id_remitente;
      this.remitente.nombre = this.remitente_selecionado.nombre;
      this.remitente.calle = this.remitente_selecionado.calle;
      this.remitente.numero_exterior = this.remitente_selecionado.numero;
      this.remitente.numero_interior = this.remitente_selecionado.numero_int;
      this.remitente.codigo_postal = this.remitente_selecionado.codigo;
      this.remitente.colonia = this.remitente_selecionado.colonia;
      this.remitente.ciudad = this.remitente_selecionado.ciudad;
      this.remitente.telefono = this.remitente_selecionado.telefono;
      service
        .buscarDestintario(this.remitente_selecionado.id_remitente)
        .then((response) => {
          if (response.data.response_flag == 1) {
            response.data.response.forEach((destinatario, count) => {
              destinatario.nombre = (count + 1) + ". " + destinatario.nombre
            });
            this.destintarios = response.data.response;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    rellenarDestinatario() {
      this.$refs.txtCalleDestintario.focus();
      this.destintario.id = this.destintario_seleccionado.id_destinatario;
      this.destintario.nombre = this.destintario_seleccionado.nombre;
      this.destintario.calle = this.destintario_seleccionado.calle;
      this.destintario.numero_exterior = this.destintario_seleccionado.numero;
      this.destintario.numero_interior =
        this.destintario_seleccionado.numero_int;
      this.destintario.codigo_postal = this.destintario_seleccionado.codigo;
      this.destintario.colonia = this.destintario_seleccionado.colonia;
      this.destintario.ciudad = this.destintario_seleccionado.ciudad;
      this.destintario.telefono = this.destintario_seleccionado.telefono;
      this.destintario.ruta_extendida = this.destintario_seleccionado.ruta_extendida;
      this.guia_extendida = this.destintario.ruta_extendida == 1;
      if (this.guia_extendida) {
        this.titulo = "Ruta Extendida";
        this.mensaje =
          "El codigo postal ingresado pertenece a una ruta extendida.";
        this.dialog_mensaje = true;
      }
    },
    mostrarConfirmacion() {
      if (this.$refs.form.validate()) {
        if (this.informacion.cantidad <= 10) {
          const inventario = (this.guia_extendida) ? this.folios_disponibles_ruta_extendida : this.folios_disponibles;
          if (inventario >= 1) {
            this.dialog_question = true;
          } else {
            this.mensaje =
              "Actualmente cuentas con " + inventario +
              " folios disponibles los cuales no son suficientes para cubrir la cantidad de " +
              this.informacion.cantidad +
              " folios. Contacta a soporte para la adquisición de más folios al telefono +52477-357-66-53.";
            this.titulo = "Folios Insuficientes";
            this.dialog_mensaje = true;
          }
        } else {
          this.mensaje = "Solo se pueden generar 10 folios por envio";
          this.titulo = "Cantidad Maxima";
          this.dialog_mensaje = true;
        }
      }
    },
    consultarFoliosDisponibles() {
      let params = {
        cliente_id: localStorage.getItem("id"),
      };
      service
        .consultarFolios(params)
        .then((response) => {
          this.loader = false;
          if (response.data.response_flag == 1) {
            this.folios_disponibles = response.data.response.guias_disponibles;
            this.folios_disponibles_ruta_extendida = response.data.response.guias_extendidas;
            if (this.folios_disponibles == 0 && this.folios_disponibles_ruta_extendida == 0) {
              this.bgColor = "error";
            }
          }
        })
        .catch(() => {
          console.log("Error");
        });
    },
    generarFolioEnvio() {
      if (this.bandera_funcion == false) {
        //Validamos que los codigos postales no sean ruta extendida
        this.bandera_funcion = true;
        this.loading = true;
        this.dialog_question = false;
        let request_service = new Object();
        //Validamos la cantidad de folios
        //Validamos para saber si es un nuevo destintatio
        let destintario = { ... this.destintario };
        destintario.ruta_extendida = (this.guia_extendida ? 1 : 0);
        let remitente = { ... this.remitente };
        let informacion = { ... this.informacion };
        destintario.nombre = destintario.nombre == undefined
          ? this.destintario_seleccionado
          : destintario.nombre;
        destintario.nombre = this.removerInicialIndice(destintario.nombre);
        destintario.id = destintario.id == undefined ? 0 : destintario.id;
        //Validamos para saber si es un remitente nuevo
        remitente.nombre = remitente.nombre == undefined
          ? this.remitente_selecionado
          : remitente.nombre;
        remitente.nombre = this.removerInicialIndice(remitente.nombre)
        remitente.id = remitente.id == undefined ? 0 : destintario.id;
        //Buscamos el tipo de empaque seleccionado
        let tipo_paquete_seleccionado = this.tipos_paquete_objecto.find(element => element.contenido == informacion.tipo_paquete);
        informacion.alto = tipo_paquete_seleccionado.alto;
        informacion.largo = tipo_paquete_seleccionado.largo;
        informacion.ancho = tipo_paquete_seleccionado.ancho;

        this.destintario = { ...destintario };
        this.remitente = { ...remitente };
        this.informacion = { ...informacion };
        request_service.destinatario = destintario;
        request_service.remitente = remitente;
        request_service.informacion = informacion;
        
        service
          .generarGuiaTest(request_service)
          .then((response) => {
            this.loading = false;
            if (response.data.response_flag == 1) {
              let archvio = response.data.response;
              this.$refs.form.reset();
              this.url = service.obtenerUrlServidor() + archvio;
              this.titulo = "Guia Generada";
              this.mensaje =
                "Se han generado correctamente la generación de folios";
              this.dialog_mensaje_correcto = true;
              this.consultarFoliosDisponibles();
            } else {
              this.error_encabezado = response.data.response;
              this.error_detalle = response.data.trace;
              this.dialog_error = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.dialog_error = true;
          })
          .finally(() => {
            this.loading = false;
            this.bandera_funcion = false;
          });
      }
    },
    removerInicialIndice(texto)
    {
      const pattern = /^\d+\./;
      let textoNuevo = texto;
      if (pattern.test(texto)){
        let arreglo= texto.split(". ");
        arreglo = arreglo.reverse();
        arreglo.pop();
        textoNuevo = arreglo.join();        
      }
      return textoNuevo
    },
  },
  computed: {
    remitentes() {
      return this.remitentes.map(remitente => ({
        ...remitente,
        formattedName: `${remitente.nombre} (ID: ${remitente.id_remitente})` // Añade el ID al nombre
      }));
    }
  }
};
</script>